import { HubDataSource, HubItemCategoryModel } from "client/Api/Hub/hub";
import { HubItemKind } from "client/Api/Hub/hubItemCategories";
import { useSynchronizedRef } from "client/Hooks";
import {
	EMPTY_ARRAY,
	isNil
} from "client/Misc/utils";
import { Navigation, NavigationCallback } from "client/Navigation";
import { ReadonlyRefObject, useEffect } from "react";
import { getHubNavigationForEvent } from "./Events/EventsPage";
import { getHubNavigationForKnowledgeItem } from "./KnowledgeItems/KnowledgeItemsPage";
import { never } from "client_legacy/ndaw/errors";
import { getHubNavigationForAnnouncement } from "./Announcements/AnnouncementsPage";

export function useUnavailableCategoryRedirect(
	itemKind: HubItemKind,
	categories: OptionalModel<readonly HubItemCategoryModel[]>,
	categoryId: number | undefined,
	onNavigate: NavigationCallback
): void {
	const categoryIdRef: ReadonlyRefObject<number | undefined> = useSynchronizedRef(categoryId);
	const categoriesRef: ReadonlyRefObject<readonly HubItemCategoryModel[]> = useSynchronizedRef(
		categories.isSet
			? categories.value
			: EMPTY_ARRAY
	);

	const didLoadCategories: boolean = categories.isSet;

	useEffect(
		(): void => {
			if (!didLoadCategories) {
				return;
			}

			const { current: categoryId } = categoryIdRef;

			if (isNil(categoryId)) {
				return;
			}

			const { current: categories } = categoriesRef;

			if (!categories.some(x => x.id === categoryId)) {
				let navigation: Navigation;

				switch (itemKind) {
					case HubItemKind.Announcement:
						navigation = getHubNavigationForAnnouncement({
							source: HubDataSource.Announcement,
							categoryId: undefined,
							itemId: undefined
						});
						break;
					case HubItemKind.KnowledgeItem:
						navigation = getHubNavigationForKnowledgeItem({
							source: HubDataSource.KnowledgeItem,
							itemId: undefined,
							viewIdentifier: undefined
						});
						break;
					case HubItemKind.Event:
						navigation = getHubNavigationForEvent({
							source: HubDataSource.Event,
							categoryId: undefined,
							itemId: undefined
						});
						break;
					default:
						never(itemKind);
				}

				onNavigate(navigation);
			}
		},
		[
			categoriesRef,
			categoryIdRef,
			didLoadCategories,
			itemKind,
			onNavigate
		]
	);
}
